import { useTranslation } from '../../i18n'
import './Privacy.css'

function Privacy() {
  const { t } = useTranslation()

  const privacyPoints = [
    { icon: '🎙️', titleKey: 'privacy1Title', descKey: 'privacy1Desc' },
    { icon: '📸', titleKey: 'privacy2Title', descKey: 'privacy2Desc' },
    { icon: '📝', titleKey: 'privacy3Title', descKey: 'privacy3Desc' },
    { icon: '🔐', titleKey: 'privacy4Title', descKey: 'privacy4Desc' },
  ] as const

  return (
    <section className="section privacy-section" aria-label="Privacy and data handling">
      <div className="container">
        <div className="privacy-header">
          <div className="privacy-icon-large">🔒</div>
          <h2>{t('privacyTitle')}</h2>
          <p>{t('privacySubtitle')}</p>
        </div>

        <div className="privacy-grid">
          {privacyPoints.map((point, index) => (
            <div key={index} className="privacy-card">
              <div className="privacy-card-icon">{point.icon}</div>
              <h3>{t(point.titleKey)}</h3>
              <p>{t(point.descKey)}</p>
            </div>
          ))}
        </div>


      </div>
    </section>
  )
}

export default Privacy
